import React from 'react';
import { WrkthruMark } from './wrkthru-mark';

/**
 * Shared centered card for Wrkthru full-page states (empty, load error). Dropped
 * down the viewport with a ringed Wrkthru badge so these states read as a
 * deliberate screen rather than a stray message.
 */
export function WrkthruNotice({
  title,
  role = 'status',
  children
}: {
  title: string;
  role?: 'status' | 'alert';
  children: React.ReactNode;
}) {
  return (
    <div className="mx-auto flex max-w-3xl justify-center px-6 pt-32 pb-12">
      <div
        className="flex max-w-xl flex-col items-center gap-5 rounded-2xl border border-slate-200 bg-white px-12 py-14 shadow-sm"
        role={role}>
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-slate-50 ring-1 ring-slate-100">
          <WrkthruMark size={44} />
        </span>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-800">{title}</h1>
        <p className="text-left text-sm leading-relaxed text-slate-500">{children}</p>
      </div>
    </div>
  );
}
